import { createSelector } from '@reduxjs/toolkit';
import { GlobalState } from '../rootReducer';
import all from '@/intl/all';

/* Action Types */
const UPDATE = '@@intl/UPDATE';

export interface State {
    readonly locale: keyof typeof all;
    readonly messages: any[];
}

/* reducer */
export const DEFAULT_STATE: State = {
    locale: 'en',
    messages: all['en'],
};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case UPDATE:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.intl;
export const getLocale = createSelector(stateSelector, (intl) => intl.locale || 'en');

/* ACTION CREATORS */
const updateIntl = ({ locale, messages }: State) => ({
    payload: { locale, messages },
    type: UPDATE,
});

export const switchLocale = (locale: State['locale']) => async (dispatch: Function) => {
    try {
        dispatch(
            updateIntl({
                locale: locale,
                messages: { ...all['en'], ...all[locale] },
            })
        );
    } catch (error) {}
};
